import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useHistory } from 'react-router';
import useTranslation from '../../../../../hooks/useTranslations';

const BusinessAreaTile = ({ businessArea }) => {
	const t = useTranslation();
	const history = useHistory();

	const handleClick = () => {
		history.push(`/${businessArea.id}`);
	};

	return (
		<div className="flex w-1/2 mb-8 max-w-tile-mobile sm:max-w-tile lg:w-1/3 2xl:w-1/4 sm:mb-16 lg:mb-[6%]">
			<button
				type="button"
				onClick={() => handleClick()}
				className="flex flex-col justify-between flex-grow mx-1.5 overflow-hidden text-left sm:mx-2.5 transform can-hover:hover:shadow-2xl can-hover:hover:scale-101 focus-visible:shadow-2xl focus-visible:scale-101 focus:outline-none rounded-[25px] border-[1px] border-white"
				aria-labelledby={`open-business-area-${t(businessArea.translationkey)}`}
			>
				<div className="relative w-full h-0 overflow-hidden" style={{ paddingBottom: '53.515625%' }}>
					<LazyLoadImage
						alt=""
						src={businessArea.image ? `${process.env.REACT_APP_API_BASE_URL}/${businessArea.image}` : `${process.env.PUBLIC_URL}/images/placeholder.png`}
						placeholderSrc={`${process.env.PUBLIC_URL}/images/placeholder.png`}
						className="absolute inset-0 object-cover w-full h-full"
						wrapperClassName="absolute inset-0 !bg-cover w-full h-full"
					/>
				</div>
				<div className="flex items-center justify-center w-full h-8 px-2 sm:h-14 lg:h-12 xl:h-14">
					<span className="text-[0.875rem] font-semibold text-white line-clamp-2 leading-4 sm:leading-6 lg:leading-5 xl:leading-6 sm:text-[1.25rem] lg:text-[1.0625rem] xl:text-[1.25rem]">
						{t(businessArea.translationkey)}
					</span>
				</div>
			</button>
		</div>
	);
};

export default BusinessAreaTile;
